/* Alpacas Foods — galeria PDP (custom element). Porta Gallery (PDP.tsx).
   Troca thumb→principal + zoom seguindo o mouse. Sem React. */
if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-main]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { this.show(parseInt(t.dataset.thumb, 10)); }.bind(this));
      }.bind(this));

      // Zoom seguindo o mouse na imagem principal.
      this.main.addEventListener('mouseenter', function () { this.main.classList.add('is-zoom'); }.bind(this));
      this.main.addEventListener('mouseleave', function () { this.main.classList.remove('is-zoom'); }.bind(this));
      this.main.addEventListener('mousemove', function (e) {
        var r = this.main.getBoundingClientRect();
        var img = this.slides[this.active] || this.main.querySelector('img');
        if (img) img.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
      }.bind(this));

      this.active = 0;

      // Setas de scroll das miniaturas — aparecem só quando há overflow;
      // a de cima some no topo e a de baixo some no fim.
      this.scroller = this.querySelector('[data-thumbs-scroll]');
      this.navUp = this.querySelector('[data-thumbs-nav="-1"]');
      this.navDown = this.querySelector('[data-thumbs-nav="1"]');
      if (this.scroller && this.navUp && this.navDown) {
        var updateNav = function () {
          var s = this.scroller;
          var vertical = s.scrollHeight > s.clientHeight + 2;
          var canScroll = vertical || s.scrollWidth > s.clientWidth + 2;
          var atStart = vertical ? s.scrollTop <= 2 : s.scrollLeft <= 2;
          var atEnd = vertical
            ? s.scrollTop + s.clientHeight >= s.scrollHeight - 2
            : s.scrollLeft + s.clientWidth >= s.scrollWidth - 2;
          if (canScroll && !atStart) this.navUp.removeAttribute('hidden'); else this.navUp.setAttribute('hidden', '');
          if (canScroll && !atEnd) this.navDown.removeAttribute('hidden'); else this.navDown.setAttribute('hidden', '');
        }.bind(this);
        [this.navUp, this.navDown].forEach(function (b) {
          b.addEventListener('click', function () {
            var dir = parseInt(b.dataset.thumbsNav, 10);
            this.scroller.scrollBy({ top: dir * this.scroller.clientHeight * 0.7, behavior: 'smooth' });
          }.bind(this));
        }.bind(this));
        this.scroller.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        window.addEventListener('load', updateNav);
        updateNav();
      }
    }

    show(i) {
      this.active = i;
      this.slides.forEach(function (s, idx) {
        if (idx === i) s.removeAttribute('hidden'); else s.setAttribute('hidden', '');
      });
      this.thumbs.forEach(function (t, idx) { t.classList.toggle('is-on', idx === i); });
    }
  });
}
